import { render, staticRenderFns } from "./OwnerList.vue?vue&type=template&id=174d47ee&"
import script from "./OwnerList.vue?vue&type=script&lang=js&"
export * from "./OwnerList.vue?vue&type=script&lang=js&"
import style0 from "./OwnerList.vue?vue&type=style&index=0&id=174d47ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports